import DossierTechniqueForm from "@features/creation/dossier-techniques/components/DossierTechniqueForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { PlusCircle } from "lucide-react";

export const Route = createFileRoute("/_app/creation/dossier-techniques/create")({
  loader: requirePermission(PERMISSIONS.CREATION.DOSSIER_TECHNIQUES.CREATE),
  staticData: {
    title: "Nouveau dossier technique",
    icon: PlusCircle,
    permission: PERMISSIONS.CREATION.DOSSIER_TECHNIQUES.CREATE,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: CreateDossierTechniquePage,
});

function CreateDossierTechniquePage() {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Nouveau dossier technique</h1>
        <p className="text-sm text-base-content/60">
          Créer un nouveau dossier technique
        </p>
      </div>
      <DossierTechniqueForm />
    </div>
  );
}